import React from "react";

const defaultDayNotes = [
  "This itinerary is flexible and can be adjusted as needed. It is recommended to keep at least a 2-hour buffer time between key activities or travel transitions.",
  "The exact pickup points and Google Maps locations will be shared in the WhatsApp group once your booking is confirmed.",
  "Timings may vary slightly due to traffic, pickup delays, or weather conditions.",
];

const ItineraryTimeline = ({ itinerary }) => {
  const getDayNumber = (dayLabel) => {
    if (!dayLabel) return Number.MAX_SAFE_INTEGER;

    const match = String(dayLabel).match(/\d+/);
    return match ? Number(match[0]) : Number.MAX_SAFE_INTEGER;
  };

  const sortedItinerary = [...itinerary].sort(
    (a, b) => getDayNumber(a.day) - getDayNumber(b.day),
  );

  return (
    <div className="px-4 pt-8 sm:px-6 lg:px-8 max-w-2xl mx-auto">
      <h2 className="text-3xl font-extrabold text-blue-600 mb-10">Itinerary</h2>

      {sortedItinerary.map((dayItem, dayIndex) => {
        const resolvedDayNotes =
          dayItem.notes && dayItem.notes.length > 0
            ? dayItem.notes
            : defaultDayNotes;

        return (
          <div
            key={`${dayItem.day}-${dayIndex}`}
            className="relative pl-6 mb-12"
          >
            <div className="absolute left-[5px] top-1 w-3 h-3 bg-blue-600 rounded-full z-10"></div>
            <div className="absolute left-[12px] top-3 bottom-0 w-px bg-blue-400"></div>

            <h3 className="text-base font-bold text-black mb-1">
              {dayItem.day}
            </h3>

            <p className="text-sm italic text-gray-600 mb-4">
              {dayItem.subheading || "Start of the journey"}
            </p>

            <div className="space-y-3 pl-4">
              {dayItem.schedule.map((entry, index) => (
                <p key={index} className="text-sm text-gray-800">
                  <span className="text-blue-600 font-semibold">
                    {entry.time}:
                  </span>{" "}
                  {entry.activity}
                </p>
              ))}
            </div>

            {dayItem.meals && (
              <div className="pt-4 pl-4">
                <p className="text-sm text-gray-800">
                  <span className="text-green-600 font-semibold">Meals:</span>{" "}
                  {dayItem.meals.join(", ")}
                </p>
              </div>
            )}

            {dayItem.notes && (
              <div className="mt-4 pl-4">
                <div className="rounded-lg border-l-4 border-red-400 bg-red-50/70 p-3 shadow-sm">
                  <p className="text-sm font-semibold text-red-600 mb-2">
                    Notes
                  </p>
                  <div className="space-y-1.5">
                    {dayItem.notes.map((note, index) => (
                      <p
                        key={index}
                        className="text-sm text-gray-800 leading-relaxed"
                      >
                        <span className="inline-block w-2 h-2 rounded-full bg-red-400 mr-2 align-middle"></span>
                        {note}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {!dayItem.notes && resolvedDayNotes.length > 0 && (
              <div className="mt-4 pl-4">
                <div className="rounded-lg border-l-4 border-red-400 bg-red-50/70 p-3 shadow-sm">
                  <p className="text-sm font-semibold text-red-600 mb-2">
                    Notes
                  </p>
                  <div className="space-y-1.5">
                    {resolvedDayNotes.map((note, index) => (
                      <p
                        key={index}
                        className="text-sm text-red-800 leading-relaxed"
                      >
                        <span className="inline-block w-2 h-2 rounded-full bg-red-400 mr-2 align-middle"></span>
                        {note}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            )}

            <div className="mt-6 border-t border-gray-200 w-full"></div>
          </div>
        );
      })}
    </div>
  );
};

export default ItineraryTimeline;
